import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedCustomerImagesTabsQueryParamsType,
  GetDamagedCustomerImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImagesTabs/getDamagedCustomerImagesTabs.type';

export const getDamagedCustomerImagesTabsQueryFunction = (
  params: GetDamagedCustomerImagesTabsQueryParamsType,
): Promise<GetDamagedCustomerImagesTabsQueryResponseType> => {
  if (params?.type && params?.type === 'initial') {
    return fetchApi.get(
      `/initial/reports/${params.id}/images/customer/entry_tabs/`,
    );
  }
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/customer/entry_tabs/`,
    { params: { damaged_id: params.damaged_id } },
  );
};
